import React, { useState } from 'react'
import './SectionItem.css'
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { config } from '../../../../../config';
import WarningDialogue from "../../../../../Util/WarningDialogue";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { EVENT_TYPE } from '../../../../../Util/helper';

export default function SectionItem(props) {
  const [popupContent, setPopupContent] = useState({});
  const [openWarningPopup, setOpenWarningPopup] = useState(false);

  const deleteItem = (props) => {
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Delete?',
      description: `Are you sure you want to delete this?`,
      icon: faExclamationCircle,
      action: () => {
        let sectionType = '';
        if (props.sectionId === 1) {
          sectionType = EVENT_TYPE.HOME_SLIDER
        } else if (props.sectionId === 2) {
          sectionType = EVENT_TYPE.VENUE
        } else if (props.sectionId === 3) {
          sectionType = EVENT_TYPE.INCLUSION
        } else if (props.sectionId === 4) {
          sectionType = EVENT_TYPE.BACKGROUND;
        }
        axiosApi.delete(`${config.apiUrl}/web-content/${sectionType}/${props?.itemDetails?.id}`)
          .then(() => {
            setOpenWarningPopup(false);
            props.itemDelete(true, sectionType);
          }).catch(() => {
            setOpenWarningPopup(false);
          })
      }
    })
  }

  return <>
    <div className='adminMenuItemContainer'>
      <span className="close" onMouseDown={() => deleteItem(props)}>
        &times;
      </span>
      <div className="disabled-blk" onMouseDown={() => props.setItemDisplay(props.itemDetails, props.sectionId, false)}>
        {(!props.itemDetails.is_visible) && <div className='adminMenuItemDisabledOverlay'>
          <div className='adminMenuItemDisabledBackground' />
          <div className='adminMenuItemDisabledContentContainer'>
            <p className='adminMenuItemDisabledText'>{!props.itemDetails.is_visible && 'Not Available'}</p>
          </div>
        </div>}
        {props.itemDetails.image !== '' && props.itemDetails.image !== null ?
          <img className='adminMenuItemImage' src={`${config.cdnUrl}/events/${props.itemDetails.image}`} alt={props.itemDetails.image} />
          :
          <div className='adminMenuMissingItemContainer'>
            {props.itemDetails.available && !props.itemDetails.hidden && <p className='adminMenuMissingItemText'>No Image</p>}
          </div>
        }
      </div>
      <div className="content-blk">
        <div className="title-blk">
          <div className="left">
            <h2 title={props?.itemDetails?.name} className='adminMenuItemTitle'>{props?.itemDetails?.name}</h2>
          </div>
        </div>
        <p className='adminMenuItemDescription'>{props.itemDetails.description}</p>
      </div>
    </div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => {setOpenWarningPopup(false); props.itemDelete(false, '');}}
    />
  </>
}